<template>
    <div class="flex flex-col md:flex-row justify-between items-center">
        <span class="text-white text-center mb-3 md:mb-0">
            <span class="font-medium">Request a recommendation from {{athleteName}}'s coach!</span>
            <span> This is not visible to the athlete.</span>
        </span>
    
        <FeedbackButton color="blueOnWhite" source="recommendation" />
    </div>
</template>

<script>
import FeedbackButton from '@/components/FeedbackRequest/Types/General'
import { mapGetters } from 'vuex'

export default {
    components: { FeedbackButton },

    computed: {
        ...mapGetters('athleteProfile', {
            athleteName: 'firstName',
        })
    }
}
</script>